<template>
  <div :class="{component: true, disabled: loading, 'component--box': true}">

    <div class="tab-buttons">
      <div @click="activeTab = 'details'; errorMessage = ''" :class="{'button--square': true, active: (activeTab === 'details')}">
        <span>Uppgifter</span>
      </div>
      <div @click="activeTab = 'skiers'; errorMessage = ''" :class="{'button--square': true, active: (activeTab === 'skiers')}">
        <span>Åkare</span>
      </div>
      <div @click="activeTab = 'passes'; errorMessage = ''" :class="{'button--square': true, active: (activeTab === 'passes')}">
        <span>Liftkort</span>
      </div>
    </div>
    
    <div class="component__inner">
      <Loading :show="loading" />

      <div class="tab-content" v-if="activeTab === 'details'">
        <h2 class="wide">Mina uppgifter</h2>

        <div class="detail-item">
          <label>Förnamn</label>
          <input type="text" placeholder="Förnamn" v-model="user.name1" />
        </div>
        <div class="detail-item">
          <label>Efternamn</label>
          <input type="text" placeholder="Efternamn" v-model="user.name2" />
        </div>
        <div class="detail-item wide">
          <label>Gatuadress</label>
          <input type="text" placeholder="Gatuadress" v-model="user.addr1" />
        </div>
        <div class="detail-item">
          <label>Postnummer</label>
          <input type="text" placeholder="Postnummer" v-model="user.addr3" />
        </div>
        <div class="detail-item">
          <label>Stad</label>
          <input type="text" placeholder="Stad" v-model="user.addr4" />
        </div>
        <div style="width:100%;height:1rem"></div>
        <div class="detail-item wide">
          <label>Land</label>
          <select v-model="user.addr5">
            <option v-for="option in filteredCountries" v-bind:key="option.value" v-bind:value="option.value">{{ option.title }}</option>
          </select>
        </div>
        <div style="width:100%;height:1rem"></div>
        <div class="detail-item wide">
          <label>Telefonnummer</label>
          <input type="tel" placeholder="Telefonnummer" v-model="user.mobile_phone" />
        </div>
        <div class="detail-item wide">
          <label>E-postadress</label>
          <input type="email" placeholder="E-postadress" v-model="user.email" />
        </div>
      </div>

      <div class="tab-content" v-if="activeTab === 'skiers'">
        <h2 class="wide">Sparade åkare</h2>

        <div class="people wide">
          <div class="person" v-for="(skier, index) in skiers" :key="index">
            <!--
            Seems like this is the measurements. Editable from admin?
            shoe: 24-49
            height: 85-195
            weight: 15-130
            -->
            <Note v-if="skier.deleted_at" color="warning" icon="trash" align="left">
              <p>{{skier.first_name || 'Åkaren'}} tas bort när du sparar</p>
            </Note>
            <div v-if="!skier.deleted_at">
              <div class="name-wrapper">
                <div class="firstname detail-item">
                  <label>Förnamn</label>
                  <input type="text" placeholder="Förnamn" v-model="skier.first_name" />
                </div>
                <div class="delete detail-item">
                  <label>&nbsp;</label>
                  <button class="button--rounded--outlined--red" @click="deleteSkier(skier, index)">Ta bort</button>
                </div>
              </div>
              <div class="multi-details">
                <div class="detail-item">
                  <label>Ålder</label>
                  <input type="text" placeholder="Ålder" v-model="skier.age" />
                </div>
                <div class="detail-item">
                  <label>Längd</label>
                  <input type="text" placeholder="Längd" v-model="skier.measurement_height" />
                </div>
                <div class="detail-item">
                  <label>Vikt</label>
                  <input type="text" placeholder="Vikt" v-model="skier.measurement_weight" />
                </div>
                <div class="detail-item">
                  <label>Skostorlek</label>
                  <input type="text" placeholder="Skostorlek" v-model="skier.measurement_shoe_size" />
                </div>
                <div class="detail-item">
                  <label>Klädstorlek</label>
                  <input type="text" placeholder="Klädstorlek" v-model="skier.measurement_clothsize" />
                </div>
              </div>
            </div>
          </div>
          <div class="center wide">
            <button class="button--rounded button--green" @click="createNewSkier()">Lägg till åkare</button>
          </div>
        </div>
      </div>

      <div class="tab-content" v-if="activeTab === 'passes'">
        <h2 class="wide">Sparade liftkort</h2>

        <div class="people wide">
          <div class="person" v-for="(skipass, index) in skipasses" :key="index">
            <Note v-if="skipass.deleted_at" color="warning" icon="trash" align="left">
              <p>{{skipass.name || 'Liftkortet'}} tas bort när du sparar</p>
            </Note>
            <div v-if="!skipass.deleted_at">
              <div class="name-wrapper">
                <div class="firstname detail-item">
                  <label>Namn på liftkort</label>
                  <p>(om du vill komma ihåg vems det är)</p>
                  <input type="text" placeholder="Namn på liftkort" v-model="skipass.name" />
                </div>
                <div class="delete detail-item">
                  <label>&nbsp;</label>
                  <button class="button--rounded--outlined--red" @click="deleteSkipass(skipass, index)">Ta bort</button>
                </div>
              </div>
              <div class="detail-item wide">
                <label>Nummer</label>
                <input type="text" placeholder="Nummer" v-model="skipass.number" />
              </div>
              <!-- <div class="detail-item wide">
                <label>Åkare</label>
                <Dropdown
                  :combo="false"
                  :options="skiersAsSelect"
                  :valuebinder.sync="skipass.skier_guid"
                  label="Välj åkare"
                  :validated="skipass.skier_guid"
                  :error="''"
                  :show-label-subtitle="false"
                  />
              </div> -->
            </div>
          </div>
          <div class="center wide">
            <button class="button--rounded" @click="createNewSkipass()">Lägg till liftkort</button>
          </div>
        </div>
      </div>

      <div style="width:100%;height:1.5rem"></div>

      <div class="center wide">
        <p class="error-message" v-if="errorMessage">{{errorMessage}}</p>
      </div>
      <div class="center wide">
        <button class="button--rounded" @click="save()">Spara</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';

import checkdigit from 'checkdigit';

import API from '@/classes/API';
import Loading from '@/components/components/Loading';
import Dropdown from '@/components/components/Dropdown';
import Note from '@/components/components/Note';
import { createValidMeasurements } from '../../../lib/measurements';

export default {
  data() {
    return {
      orders: [],
      user: {},
      loading: false,
      errorMessage: '',
      countries: [],
      skiers: [],
      skipasses: [],
      activeTab: 'details',
    };
  },
  components: {
    Loading,
    Dropdown,
    Note,
  },
  computed: {
    ...mapGetters([
      'loggedIn',
    ]),
    filteredCountries() {
      const countries = this.countries.filter(country => country.value !== '----');

      const match = countries.filter(country => country.value === this.user.addr5);

      if (match.length) {
        return countries;
      }

      countries.push({
        value: '',
        title: '[ Inget valt ]',
      });

      return countries;
    },
    skiersAsSelect() {
      return this.skiers.map(s => ({
        value: s.guid,
        title: s.first_name || 'Ingen åkare',
      }));
    },
  },
  methods: {
    ...mapMutations([
      'openModal',
      'closeModal',
    ]),
    async fetch() {
      this.loading = true;
      const { user, skiers, skipasses } = await API.get('/account/user');
      if (user) {
        this.user = user;
      }
      this.skiers = skiers;
      this.skipasses = skipasses;
      this.loading = false;
    },
    preValidate(intent) {
      if (intent === 'skiers') {
        let valid = true;
        this.skiers.forEach((skier, index) => {
          if (!valid) return;
          if (!skier.deleted_at) {
            // Name
            if (!skier.first_name || skier.first_name.trim() === '') {
              this.errorMessage = 'Alla åkare måste ha ett förnamn.';
              valid = false;
              return;
            }

            const skierName = skier.first_name || `Åkare #${index + 1}`;

            // Age
            if (skier.age && skier.age.toString().trim() !== '') {
              if (isNaN(parseInt(skier.age, 10))) {
                this.errorMessage = `${skierName} måste ha en giltig ålder`;
                valid = false;
                return;
              }
              if (parseInt(skier.age, 10) < 0 || parseInt(skier.age, 10) > 130) {
                this.errorMessage = `${skierName} måste ha en giltig ålder`;
                valid = false;
                return;
              }
            }

            const allowedMeasurements = createValidMeasurements({
              cmMin: 85,
              cmMax: 195,
              cmInterval: 1,
              kgMin: 15,
              kgMax: 130,
              kgInterval: 1,
              shoeMin: 24,
              shoeMax: 49,
              shoeInterval: 1,
            }, this.$i18n.t.bind(this.$i18n));

            // Check length
            if (skier.measurement_height && skier.measurement_height.toString().trim() !== '') {
              const heightOptions = allowedMeasurements.lengthOptions
                .map(l => l.value);
              if (!heightOptions
                .includes(parseInt(skier.measurement_height, 10))) {
                const min = allowedMeasurements.lengthOptions[0].value;
                const max = allowedMeasurements
                  .lengthOptions[allowedMeasurements.lengthOptions.length - 1].value;
                this.errorMessage = `${skierName} måste ha en giltig längd mellan ${min}-${max} cm`;
                valid = false;
                return;
              }
            }

            // Check weight
            if (skier.measurement_weight && skier.measurement_weight.toString().trim() !== '') {
              const weightOptions = allowedMeasurements.weightOptions
                .map(w => w.value);
              if (!weightOptions
                .includes(parseInt(skier.measurement_weight, 10))) {
                const min = allowedMeasurements.weightOptions[0].value;
                const max = allowedMeasurements
                  .weightOptions[allowedMeasurements.weightOptions.length - 1].value;
                this.errorMessage = `${skierName} måste ha en giltig vikt mellan ${min}-${max} kg`;
                valid = false;
                return;
              }
            }

            // Check shoe size
            if (skier.measurement_shoe_size && skier.measurement_shoe_size.toString().trim() !== '') {
              const shoeSizeOptions = allowedMeasurements.shoeSizeOptions
                .map(s => s.value);
              if (!shoeSizeOptions
                .includes(parseInt(skier.measurement_shoe_size, 10))) {
                const min = allowedMeasurements.shoeSizeOptions[0].value;
                const max = allowedMeasurements
                  .shoeSizeOptions[allowedMeasurements.shoeSizeOptions.length - 1].value;
                this.errorMessage = `${skierName} måste ha en giltig skostorlek mellan ${min}-${max}`;
                valid = false;
                return;
              }
            }

            // Check clothing size
            if (skier.measurement_clothsize && skier.measurement_clothsize.toString().trim() !== '') {
              const clothSizes = allowedMeasurements.clothSizeOptions
                .map(c => c.value);
              if (!clothSizes.includes(skier.measurement_clothsize)) {
                this.errorMessage = `${skierName} måste ha en giltig klädstorlek. Välj mellan: ${clothSizes.join(' / ')}`;
                valid = false;
              }
            }
          }
        });
        if (!valid) return false;
      }

      if (intent === 'passes') {
        let valid = true;
        this.skipasses.forEach((skipass, index) => {
          if (!valid) return;

          const passname = skipass.name || `Liftkort #${index + 1}`;

          if (!skipass.deleted_at) {
            // Number
            if (!skipass.number || skipass.number.trim() === '') {
              this.errorMessage = `${passname} måste ha ett nummer.`;
              valid = false;
              return;
            }

            // Check that the number only contains digits and dashes
            if (!/^[\d-]+$/.test(skipass.number)) {
              this.errorMessage = `${passname} får endast innehålla siffror och bindestreck.`;
              valid = false;
              return;
            }

            const fullNumberWithoutDashes = skipass.number.replace(/-/g, '');

            if (fullNumberWithoutDashes.length < 23) {
              this.errorMessage = `${passname} måste vara exakt 23 siffror långt (inklusive 01/30 i början).`;
              valid = false;
              return;
            }

            // Check that it starts with 01 or 30
            if (!fullNumberWithoutDashes.startsWith('01') && !fullNumberWithoutDashes.startsWith('30')) {
              this.errorMessage = `${passname} måste börja med 01 eller 30.`;
              valid = false;
              return;
            }

            if (checkdigit.mod10.isValid(fullNumberWithoutDashes) === false) {
              this.errorMessage = `${passname} har ett ogiltigt nummer. Kontrollera att numret är korrekt.`;
              valid = false;
            }
          }
        });
        if (!valid) return false;
      }

      return true;
    },
    async save() {
      this.loading = true;
      let intent = 'details';

      if (this.activeTab === 'skiers') {
        intent = 'skiers';
      } else if (this.activeTab === 'passes') {
        intent = 'passes';
      }

      if (!this.preValidate(intent)) {
        this.loading = false;
        return;
      }

      const { success, errorMessage } = await API.post(`/account/update?intent=${intent}`, {
        user: this.user,
        skiers: this.skiers,
        skipasses: this.skipasses,
      });
      this.loading = false;
      if (!success) {
        this.errorMessage = errorMessage;
      } else {
        this.errorMessage = '';

        this.openModal(['GeneralModal', {
          title: 'Sparat',
          content: 'Dina uppgifter har sparats.',
        }]);

        this.fetch();
      }
    },
    async fetchCountries() {
      const data = await API.get('countries');
      this.countries = data;
    },
    createNewSkier() {
      this.skiers.push({
        age: '',
        first_name: '',
        last_name: '',
        measurement_height: '',
        measurement_weight: '',
        measurement_shoe_size: '',
        measurement_clothsize: '',
      });
    },
    createNewSkipass() {
      this.skipasses.push({
        name: '',
        number: '',
        skier_guid: '',
      });
    },
    deleteSkier(skier, index) {
      const name = skier.first_name || 'åkaren';
      const $this = this;

      this.openModal(['GeneralModal', {
        title: 'Radera',
        content: `<p>Vill du verkligen ta bort ${name.trim()}?</p>`,
        buttons: [
          {
            title: 'Ja',
            class: '',
            click: () => {
              $this.$set($this.skiers, index, {
                ...skier,
                deleted_at: true,
              });
              $this.closeModal();
            },
          },
        ],
      }]);
    },
    deleteSkipass(skipass, index) {
      let name = skipass.name ? `${skipass.name} (${skipass.number})` : skipass.number;
      if (!name || name.trim() === '') {
        name = 'liftkortet';
      }
      const $this = this;

      this.openModal(['GeneralModal', {
        title: 'Radera',
        content: `<p>Vill du verkligen ta bort ${name.trim()}?</p>`,
        buttons: [
          {
            title: 'Ja',
            class: '',
            click: () => {
              $this.$set($this.skipasses, index, {
                ...skipass,
                deleted_at: true,
              });
              $this.closeModal();
            },
          },
        ],
      }]);
    },
  },
  mounted() {
    this.fetch();
    this.fetchCountries();
  },
};
</script>

<style scoped lang="stylus">
@import '~@/global.styl'
@import '~@/global-v2.styl'

.tab-buttons
  display flex
  justify-content: center
  flex-wrap wrap
  margin-bottom 2rem
  & > *
    margin: 0.25em
    text-align: center
    @media (max-width: 650px)
      width calc(50% - 0.5em)

.detail-item
  margin-bottom 1rem
  width 48%
  margin-bottom: 1.5rem
  +max-xs-mobile()
    width: 100% !important

.wide
  width 100%

.component
  background-color white
  padding: 2rem
  padding-top 3rem
  width: 100%
  display: block

  .component__inner
    max-width 539px
    margin 0 auto
    display flex
    flex-wrap wrap
    justify-content space-between
    .tab-content
      margin 0 auto
      display flex
      flex-wrap wrap
      justify-content space-between
      width 100%
      label
        v2-label()

.disabled
  disabled-grey()

input[type="text"], input[type="email"], input[type="tel"], select
  v2-input()

.error-message
  margin-top 10px
  margin-bottom 10px

.people
  margin-bottom: 1.5rem;
  .person
    padding: 2rem 0;
    border-bottom: solid 2px shadow-blue-2;
    .name-wrapper
      display flex
      .firstname
        flex: 1
        padding-right: 1rem
      .delete
        flex: 0 0 auto
    .multi-details
      display flex
      flex-wrap wrap
      justify-content space-between
      & > div
        width: 48%;
        @media(min-width: 600px)
          width: 23%;
</style>



// WEBPACK FOOTER //
// MyPageDetails.vue?ad7c001e